import React, { createContext, useState } from 'react';

export const LayoutContext = createContext('theme-light');

function LayoutProvider({ children }) {
	const [theme, setTheme] = useState('theme-light');

	return (
		<LayoutContext.Provider
			value={{
				theme,
				setTheme,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
}

export default LayoutProvider;
